import React from 'react'
import {willUseSharedState} from '@startlibs/core'
import _ from 'lodash/fp'

export const [useUploadLog,,setUploadLog] = willUseSharedState([])


export const appendLog = (files,status,errorMessage='') => {
  setUploadLog(_.unionBy('file',[].concat(files).map(file => ({file,status,date:Date.now(),errorMessage}))))
}